"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILocalSpatialAudioEngineDispatch = void 0;
const native_rtc_1 = require("@iris/native-rtc");
const AgoraConsole_1 = require("../util/AgoraConsole");
class ILocalSpatialAudioEngineDispatch {
    constructor(engine) {
        this._engine = engine;
    }
    // @ts-ignore
    release() {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_release not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    initialize_cf94fbf() {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_initialize_cf94fbf not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateRemotePosition_adc0909(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_updateRemotePosition_adc0909 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateRemotePositionEx_f0252d9(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_updateRemotePositionEx_f0252d9 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    removeRemotePosition_c8d091a(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_removeRemotePosition_c8d091a not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    removeRemotePositionEx_58a9850(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_removeRemotePositionEx_58a9850 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    clearRemotePositionsEx_c81e1a4(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_clearRemotePositionsEx_c81e1a4 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateSelfPositionEx_502183a(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_updateSelfPositionEx_502183a not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setMaxAudioRecvCount_46f8ab7(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_setMaxAudioRecvCount_46f8ab7 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setAudioRecvRange_685e803(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_setAudioRecvRange_685e803 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setDistanceUnit_685e803(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_setDistanceUnit_685e803 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updateSelfPosition_9c9930f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_updateSelfPosition_9c9930f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    updatePlayerPositionInfo_b37c59d(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_updatePlayerPositionInfo_b37c59d not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setParameters_3a2037f(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_setParameters_3a2037f not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    muteLocalAudioStream_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_muteLocalAudioStream_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    muteAllRemoteAudioStreams_5039d15(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_muteAllRemoteAudioStreams_5039d15 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    muteRemoteAudioStream_dbdc15a(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_muteRemoteAudioStream_dbdc15a not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setRemoteAudioAttenuation_74c3e98(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_setRemoteAudioAttenuation_74c3e98 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setZones_414a27e(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_setZones_414a27e not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    setPlayerAttenuation_a15bc51(apiParam) {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_setPlayerAttenuation_a15bc51 not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
    // @ts-ignore
    clearRemotePositions() {
        AgoraConsole_1.AgoraConsole.warn('LocalSpatialAudioEngine_clearRemotePositions not supported in this platform!');
        return this._engine.returnResult(false, -native_rtc_1.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
    }
}
exports.ILocalSpatialAudioEngineDispatch = ILocalSpatialAudioEngineDispatch;
